import { updateProjectScorecardQuestionsDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const updateProjectScorecardQuestionsCallable = getCallable(
  updateProjectScorecardQuestionsDefinition,
);
